$(document).ready(function () {
  var title = $(".product_name").text();

  // if (title.indexOf("Ornament") != -1 || title.indexOf("ornament") != -1) {
  //   $(".tab-links").append(
  //     '<li  ><a href="#tab3"><span> <i class="fa fa-users"></i> Product Reviews (Youtube) </span></a></li>'
  //   );
  //   $("#tab3").html(
  //     '<iframe width="100%" height="300" src="https://www.youtube.com/embed/_qE5ofd8tVk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
  //   );
  // }
  // if (
  //   title.indexOf("Tumbler") != -1 ||
  //   title.indexOf("tumbler") != -1 ||
  //   title.indexOf("Cup") != -1 ||
  //   title.indexOf("cup") != -1
  // ) {
  //   $(".tab-links").append(
  //     '<li  ><a href="#tab3"><span> <i class="fa fa-users"></i> Product Reviews (Youtube) </span></a></li>'
  //   );
  //   $("#tab3").html(
  //     '<iframe width="100%" height="300" src="https://www.youtube.com/embed/e_GcKdFRgpc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
  //   );
  // }
  // if (title.indexOf("blanket") != -1 && title.indexOf("racing") != -1) {
  //   $(".tab-links").append(
  //     '<li  ><a href="#tab3"><span> <i class="fa fa-users"></i> Product Reviews (Youtube) </span></a></li>'
  //   );
  //   $("#tab3").html(
  //     '<iframe width="100%" height="300" src="https://www.youtube.com/embed/7BgrWrfNVnU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
  //   );
  // }
  // if (title.indexOf("Blanket") != -1 && title.indexOf("Racing") != -1) {
  //   $(".tab-links").append(
  //     '<li  ><a href="#tab3"><span> <i class="fa fa-users"></i> Product Reviews (Youtube) </span></a></li>'
  //   );
  //   $("#tab3").html(
  //     '<iframe width="100%" height="300" src="https://www.youtube.com/embed/7BgrWrfNVnU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
  //   );
  // }

  $(".tabs .tab-links li ").click(function (e) {
    var currentAttrValue = $(this).find("a").attr("href");
    // Show/Hide Tabs
    $(".tabs " + currentAttrValue)
      .fadeIn(400)
      .siblings()
      .hide();
    // Change/remove current tab to active
    $(this).addClass("active").siblings().removeClass("active");
    e.preventDefault();
  });

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let now = new Date(); // Hàm lấy thời gian hôm nay
  let now2 = new Date();
  let order_day = new Date();
  let ship_day = new Date();
  let ship_day1 = new Date();
  let delivery_day = new Date();
  let delivery_day1 = new Date();

  var array = title.split(" ");

  var type_sc = $(".product_type_sc").text();
  console.log(type_sc.search("Mug") == -1);

  if (
    type_sc == "Coffee Mug" ||
    type_sc == "Apparel" ||
    type_sc == "Magic Mug"
  ) {
    let ship_nextWeek = addDays(ship_day, 3);
    let ship_nextWeek1 = addDays(ship_day1, 5);

    let delivery_nextWeek = addDays(delivery_day, 10);
    let delivery_nextWeek1 = addDays(delivery_day1, 16);

    $("#order_day").text(
      monthNames[order_day.getMonth()] + " " + order_day.getDate()
    );

    if (
      monthNames[ship_nextWeek.getMonth()] ===
      monthNames[ship_nextWeek1.getMonth()]
    ) {
      $("#ship_day").text(
        monthNames[ship_nextWeek.getMonth()] +
          " " +
          ship_nextWeek.getDate() +
          "-" +
          ship_nextWeek1.getDate()
      );
    } else {
      $("#ship_day").text(
        monthNames[ship_nextWeek.getMonth()] +
          " " +
          ship_nextWeek.getDate() +
          " - " +
          monthNames[ship_nextWeek1.getMonth()] +
          " " +
          ship_nextWeek1.getDate()
      );
    }

    if (
      monthNames[delivery_nextWeek.getMonth()] ===
      monthNames[delivery_nextWeek1.getMonth()]
    ) {
      $("#notify_arrives").text(
        monthNames[delivery_nextWeek.getMonth()] +
          " " +
          delivery_nextWeek.getDate() +
          "-" +
          delivery_nextWeek1.getDate()
      );
      $("#delivered_day").text(
        monthNames[delivery_nextWeek.getMonth()] +
          " " +
          delivery_nextWeek.getDate() +
          "-" +
          delivery_nextWeek1.getDate()
      );
    } else {
      $("#notify_arrives").text(
        monthNames[delivery_nextWeek.getMonth()] +
          " " +
          delivery_nextWeek.getDate() +
          " - " +
          monthNames[delivery_nextWeek1.getMonth()] +
          " " +
          delivery_nextWeek1.getDate()
      );
      $("#delivered_day").text(
        monthNames[delivery_nextWeek.getMonth()] +
          " " +
          delivery_nextWeek.getDate() +
          " - " +
          monthNames[delivery_nextWeek1.getMonth()] +
          " " +
          delivery_nextWeek1.getDate()
      );
    }
  } else if (type_sc == "Ornament") {
    let ship_nextWeek = addDays(ship_day, 3);
    let ship_nextWeek1 = addDays(ship_day1, 5);

    let delivery_nextWeek = addDays(delivery_day, 10);
    let delivery_nextWeek1 = addDays(delivery_day1, 16);

    $("#order_day").text(
      monthNames[order_day.getMonth()] + " " + order_day.getDate()
    );

    if (
      monthNames[ship_nextWeek.getMonth()] ===
      monthNames[ship_nextWeek1.getMonth()]
    ) {
      $("#ship_day").text(
        monthNames[ship_nextWeek.getMonth()] +
          " " +
          ship_nextWeek.getDate() +
          "-" +
          ship_nextWeek1.getDate()
      );
    } else {
      $("#ship_day").text(
        monthNames[ship_nextWeek.getMonth()] +
          " " +
          ship_nextWeek.getDate() +
          " - " +
          monthNames[ship_nextWeek1.getMonth()] +
          " " +
          ship_nextWeek1.getDate()
      );
    }

    if (
      monthNames[delivery_nextWeek.getMonth()] ===
      monthNames[delivery_nextWeek1.getMonth()]
    ) {
      $("#notify_arrives").text(
        monthNames[delivery_nextWeek.getMonth()] +
          " " +
          delivery_nextWeek.getDate() +
          "-" +
          delivery_nextWeek1.getDate()
      );
      $("#delivered_day").text(
        monthNames[delivery_nextWeek.getMonth()] +
          " " +
          delivery_nextWeek.getDate() +
          "-" +
          delivery_nextWeek1.getDate()
      );
    } else {
      $("#notify_arrives").text(
        monthNames[delivery_nextWeek.getMonth()] +
          " " +
          delivery_nextWeek.getDate() +
          " - " +
          monthNames[delivery_nextWeek1.getMonth()] +
          " " +
          delivery_nextWeek1.getDate()
      );
      $("#delivered_day").text(
        monthNames[delivery_nextWeek.getMonth()] +
          " " +
          delivery_nextWeek.getDate() +
          " - " +
          monthNames[delivery_nextWeek1.getMonth()] +
          " " +
          delivery_nextWeek1.getDate()
      );
    }
  } else {
    let ship_nextWeek = addDays(ship_day, 3);
    let ship_nextWeek1 = addDays(ship_day1, 5);

    let delivery_nextWeek = addDays(delivery_day, 10);
    let delivery_nextWeek1 = addDays(delivery_day1, 16);

    $("#order_day").text(
      monthNames[order_day.getMonth()] + " " + order_day.getDate()
    );

    if (
      monthNames[ship_nextWeek.getMonth()] ===
      monthNames[ship_nextWeek1.getMonth()]
    ) {
      $("#ship_day").text(
        monthNames[ship_nextWeek.getMonth()] +
          " " +
          ship_nextWeek.getDate() +
          "-" +
          ship_nextWeek1.getDate()
      );
    } else {
      $("#ship_day").text(
        monthNames[ship_nextWeek.getMonth()] +
          " " +
          ship_nextWeek.getDate() +
          " - " +
          monthNames[ship_nextWeek1.getMonth()] +
          " " +
          ship_nextWeek1.getDate()
      );
    }

    if (
      monthNames[delivery_nextWeek.getMonth()] ===
      monthNames[delivery_nextWeek1.getMonth()]
    ) {
      $("#notify_arrives").text(
        monthNames[delivery_nextWeek.getMonth()] +
          " " +
          delivery_nextWeek.getDate() +
          "-" +
          delivery_nextWeek1.getDate()
      );
      $("#delivered_day").text(
        monthNames[delivery_nextWeek.getMonth()] +
          " " +
          delivery_nextWeek.getDate() +
          "-" +
          delivery_nextWeek1.getDate()
      );
    } else {
      $("#notify_arrives").text(
        monthNames[delivery_nextWeek.getMonth()] +
          " " +
          delivery_nextWeek.getDate() +
          " - " +
          monthNames[delivery_nextWeek1.getMonth()] +
          " " +
          delivery_nextWeek1.getDate()
      );
      $("#delivered_day").text(
        monthNames[delivery_nextWeek.getMonth()] +
          " " +
          delivery_nextWeek.getDate() +
          " - " +
          monthNames[delivery_nextWeek1.getMonth()] +
          " " +
          delivery_nextWeek1.getDate()
      );
    }
  }
});

function addDays(dateObj, numDays) {
  dateObj.setDate(dateObj.getDate() + numDays);
  return dateObj;
}

$(".swatch_options .swatch-radio-hidden").change(function (e) {
  setTimeout(() => {
    const countSwatch = $(".swatch_options").find(".swatch").length;
    var dataId = "";
    for (let i = 0; i < countSwatch; i++) {
      if (i > $(this).parent().data("option-index")) {
        for (
          let j = 0;
          j <
          $(".swatch_options")
            .find(".swatch:nth-child(" + (i + 1) + ")")
            .children().length;
          j++
        ) {
          if (
            $(".swatch_options")
              .find(".swatch:nth-child(" + (i + 1) + ")")
              .children("div:nth-child(" + (j + 1) + ")")
              .hasClass("soldout")
          ) {
            swatchDataId = $(".swatch_options")
              .find(".swatch:nth-child(" + (i + 1) + ")")
              .children("div:nth-child(" + (j + 1) + ")")
              .data("id");
            if (
              $(".swatch_options")
                .find(".swatch:nth-child(" + (i + 1) + ")")
                .children("input[data-id=" + swatchDataId + "]")
                .is(":checked")
            ) {
              for (
                let n = 0;
                j <
                $(".swatch_options")
                  .find(".swatch:nth-child(" + (i + 1) + ")")
                  .children().length;
                n++
              ) {
                if (
                  $(".swatch_options")
                    .find(".swatch:nth-child(" + (i + 1) + ")")
                    .children("div:nth-child(" + (n + 1) + ")")
                    .hasClass("available") &&
                  !$(".swatch_options")
                    .find(".swatch:nth-child(" + (i + 1) + ")")
                    .children("div:nth-child(" + (n + 1) + ")")
                    .hasClass("soldout")
                ) {
                  var stringFor = $(".swatch_options")
                    .find(".swatch:nth-child(" + (i + 1) + ")")
                    .children("div:nth-child(" + (n + 1) + ")")
                    .data("id");
                  $(".swatch_options")
                    .find(".swatch:nth-child(" + (i + 1) + ")")
                    .children("input[data-id=" + stringFor + "]")
                    .click();
                  break;
                }
              }
            } else {
              continue;
            }
          } else {
            continue;
          }
        }
      }
    }
  }, 5);
});

/*============================================================================
  Tab product
==============================================================================*/
tabControl();

function tabControl() {
  var tabs = $(".tabbed-content").find(".tabs");
  if (tabs.is(":visible")) {
    tabs.find("a").on("click", function (event) {
      event.preventDefault();
      var target = $(this).attr("href"),
        tabs = $(this).parents(".tabs"),
        buttons = tabs.find("a"),
        item = tabs.parents(".tabbed-content").find(".item");
      buttons.removeClass("active");
      item.removeClass("active");
      $(this).addClass("active");
      $(target).addClass("active");
    });
  } else {
    $(".item").on("click", function () {
      var container = $(this).parents(".tabbed-content"),
        currId = $(this).attr("id"),
        items = container.find(".item");
      container.find(".tabs a").removeClass("active");
      items.removeClass("active");
      $(this).addClass("active");
      container.find('.tabs a[href$="#' + currId + '"]').addClass("active");
    });
  }
}

/*============================================================================
  Onload
==============================================================================*/
$(window).on("load", function () {
  setTimeout(function () {
    $(".vue-portal-target .customily-modal-preview-only .main").append(
      '<div class="button-preview">' +
        '<button type="button" name="add" class=" customily-add-to-cart-btn ajax-submit  action_button--secondary customily_submit_preview" data-label="{{ add_to_cart_label | json }}" style="width: 100%;width: 100%;padding: 10px;color: white;background: #fc6514;"> ADD TO CART </button>' +
        "</div>"
    );

    // $('.customily-preview-button.ld-over-inverse').appendTo($('.shopify-product-form'));
    $(
      ".add_to_cart.global-button.global-button--secondary.ld-over-inverse"
    ).prepend(
      '<span style="padding: 10px;"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="fill: white;"> <g clip-path="url(#clip0)"> <path d="M22 9.10002C21.7 9.00002 21.5 9.10002 21.3 9.20002C21.1 9.40002 20.9 9.60002 20.9 9.90002L19.6 16.8H7.3C6.6 13.3 5.3 6.90002 5.1 6.10002C4.7 4.60002 3.3 4.40002 2.7 4.40002H1C0.5 4.40002 0 4.80002 0 5.40002C0 6.00002 0.4 6.40002 1 6.40002H2.8C3 6.40002 3.1 6.50002 3.1 6.50002C3.1 6.50002 3.1 6.50002 3.1 6.60002C3.3 7.30002 4 10.6 4.6 13.8C5.2 16.7 5.7 19.4 5.7 19.5C5.7 19.6 5.7 19.6 5.8 19.7C5.1 20.1 4.6 20.9 4.6 21.7C4.7 22.9 5.7 24 7 24C8.3 24 9.3 22.9 9.3 21.7V21.4H15.8V21.7C15.8 23 16.9 24 18.1 24C19.4 24 20.4 23 20.4 21.7C20.4 20.4 19.4 19.4 18.1 19.4H8.2C7.9 19.4 7.8 19.3 7.8 19.2C7.8 19.2 7.8 19 7.7 18.9H20.5C21 18.9 21.3 18.6 21.4 18.1L22.9 10.2C23 9.70002 22.6 9.20002 22 9.10002ZM7.3 21.6C7.3 21.8 7.1 21.9 7 21.9C6.9 21.9 6.7 21.7 6.7 21.6C6.7 21.4 6.9 21.3 7 21.3C7.1 21.3 7.3 21.4 7.3 21.6ZM17.7 21.6C17.7 21.4 17.9 21.3 18 21.3C18.2 21.3 18.3 21.5 18.3 21.6C18.3 21.8 18.1 21.9 18 21.9C17.9 21.9 17.7 21.7 17.7 21.6Z" fill="white"></path></g> <defs> <clipPath id="clip0"> <rect width="24" height="24" fill="white"></rect></clipPath></defs></svg></span>'
    );
    $(".vue-portal-target").appendTo($(".product_form .shopify-product-form"));

    $(".customily_submit_preview").click(function () {
      $(".customily-modal-preview-only").css("display", "none");
      $("body").removeClass("disable-scroll");
      $("#customily-cart-btn").click();
    });
  }, 5000);
});

function openModal() {
  $(".modal-upload-picture-guide").css("display", "block");
}
function closeModal() {
  $(".modal-upload-picture-guide").css("display", "none");
}
$(".size-guild").click(function () {
  $(".modal-size-guild").addClass("active");
  $("body").css("overflow", "hidden");
});
$(".close-modal-size-guild").click(function () {
  $(".modal-size-guild").removeClass("active");
  $("body").css("overflow", "inherit");
});
$(".preview-fixed-btn").click(() => {
  $(".customily-preview-button").click();
});

$(".tabs-ver-2 .tab .title").click(function () {
  if ($(this).parent().find(".content").hasClass("active")) {
    $(this).siblings(".content").removeClass("active");
  } else {
    $(".tabs-ver-2 .tab .content").removeClass("active");
    $(this).siblings(".content").addClass("active");
  }
});
